/* eslint-disable */
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import TablePagination from '../../../common/components/TablePagination';
import dashboardlabels from '../../dashboard/labels/dashboard_en.json';
import '../../styles/approval_user.css';
import { deleteRequest, getAllApprovalUser, getSingleApprovalDetails } from '../actions/userAction';
import UpdateApprovalUser from '../components/UpdateApprovalUser';
import userLabels from '../labels/users_en.json';
import ApprovalUser from './ApprovalUser';


const ApprovalUserTable = ({ hasUpdateMasterPermission, hasDeletMasterPermission }) => {
  let [listCurrentPage, setListCurrentPage] = useState(0);
  const dispatch = useDispatch();
  const { getApprovalUser } = useSelector(
    (state) => state.userManagementReducer,
    shallowEqual
  );
  let [showUpdateApprovalUserModal, setShowUpdateApprovalUserModal] = useState(false);
  let [showDeleteModal, setShowDeleteModal] = useState(false)
  let [selectedUserRequest, setSelectedUserRequest] = useState("")
  // let [editEle, setEditEle] = useState({})
  let [approvalUserModal, setApprovalUserModal] = useState(false);
  let [selectedApprovalUser, setSelectedApprovalUser] = useState("");

  const handleEditApprovalUser = (ele) => {
    setSelectedApprovalUser(ele)
    setShowUpdateApprovalUserModal(true)
    dispatch(getSingleApprovalDetails(ele.id))
  }
  const handleDeleteApprovalUser = (ele) => {
    setShowDeleteModal(true)
    setSelectedUserRequest(ele)
  }
  const comfirmDeleteUserModal = (ele) => {
    dispatch(deleteRequest(ele.id))
    setShowDeleteModal(false)
  }
  useEffect(() => {
    dispatch(getAllApprovalUser(0, 10));
    // eslint-disable-next-line
  }, [])

  const handleApprovalUser = (ele) => {
    setSelectedApprovalUser(ele)
    setApprovalUserModal(true)
    ele &&  dispatch(getSingleApprovalDetails(ele.id))
  }

  const handleApproveUser = () =>{
    dispatch(approveUserFun())
  }

  const statusColor = (status) => {
    if (status === "Rejected") {
      return "word-break rejected"
    } else if (status === "Published") {
      return "word-break published"
    } else {
      return "word-break"
    }
  }
  return (
    <div className="border border-light table-responsive " style={{ textAlign: "center", width: "100%", padding: "20px" }}>
      <table className='table'>
        <thead className="table-primary">
          <tr>
            {userLabels.approvalUserHeaderContent.map((ele, index) =>
              <th scope="col" style={{ width: "80px" }} key={index} >{ele}</th>
            )}
          </tr>
        </thead>
        <tbody style={{ fontSize: "12px" }}>
          {
            getApprovalUser.entityApprovalDtoList && getApprovalUser.entityApprovalDtoList.sort((a, b) => a.updatedAt < b.updatedAt ? - 1 : 1).reverse().map(({ entityApprovalAction }, index) => {
              const entityApprovalDto = entityApprovalAction.entityApprovalDto
              const { approvalType, updatedAt, isDeleted } = entityApprovalDto
              const { createdBy, departmentId, email, firstName, id, isActive, isTempPassword, lastName, mobile, password, roleId, supervisorName, updatedBy, username } = JSON.parse(entityApprovalDto.detail)
              if (!isDeleted) {
                return (
                  <tr key={index}>
                    <td className="word-break">{approvalType}</td>
                    <td className={statusColor(isActive)}>{isActive}</td>
                    <td style={{ width: "12%" }} className="text-nowrap">{updatedAt ? dayjs(updatedAt).format('DD/MM/YYYY h:mm A') : ""}</td>
                    <td className="word-break">{firstName}</td>
                    <td className="word-break">{lastName}</td>
                    <td style={{ width: "12%" }} className="word-break">{roleId}</td>
                    <td className="word-break">{departmentId}</td>
                    <td className="word-break">""</td>
                    <td className="word-break">""</td>
                    <td className="word-break d-flex align-items-center gap-2">
                      {hasUpdateMasterPermission &&
                        <i data-toggle="tooltip" title="Update User" style={{ fontSize: "15px", color: "#007bff", cursor: 'pointer' }} className='fa fa-edit' aria-hidden="true" onClick={() => { handleEditApprovalUser(entityApprovalDto) }}></i>
                      }
                      {hasDeletMasterPermission &&
                        <i data-toggle="tooltip" title="Delete User" style={{ fontSize: "15px", color: "red", cursor: 'pointer' }} className='fa fa-trash' aria-hidden="true" onClick={() => { handleDeleteApprovalUser(entityApprovalDto) }}></i>
                      }
                      <button type="button" style={{ fontSize: "11px", cursor: 'pointer' }} className="pull-right btn btn-outline-primary  custom_button  btn-sm text-nowrap" onClick={() => { handleApprovalUser(entityApprovalDto) }}>
                        {dashboardlabels.REVIEW}
                      </button>
                      {/* : ""} */}
                    </td>
                  </tr>
                )
              }
            })
          }
          {/* {
            getApprovalUser && getApprovalUser.initiatedApprovals && getApprovalUser.initiatedApprovals.sort((a, b) => a.updatedOn < b.updatedOn ? - 1 : 1).map((ele, index) => {
              if (!ele.flgDeleted) {
                return (
                  <tr key={index}>
                    <td className="word-break">{ele.userOasApproval.approvalType}</td>
                    <td className={statusColor(ele.userOasApproval.status)}>{ele.userOasApproval.status}</td>
                    <td style={{ width: "12%" }} className="word-break">{ele.updatedOn ? dayjs(ele.updatedOn).format('DD/MM/YYYY h:mm A') : ""}</td>
                    <td className="word-break">{ele.userOasApproval.firstName}</td>
                    <td className="word-break">{ele.userOasApproval.lastName}</td>
                    <td style={{ width: "12%" }} className="word-break">{ele.roleName}</td>
                    <td className="word-break">{ele.departmentName}</td>
                    <td className="word-break">{ele.lastApprover}</td>
                    <td className="word-break">{ele.lastApproverComments}</td>
                    <td style={{ width: "5%" }} className="word-break" >
                      {
                        <i style={{ fontSize: "15px", color: "#93a5ea", marginRight: "8px" }} className='fa fa-edit disabled-link' aria-hidden="true" disabled={true}></i>}
                      <i style={{ fontSize: "15px", color: "#c5a3a3", marginLeft: "8px" }} className='fa fa-trash disabled-link' aria-hidden="true" disabled={true}></i>
                    </td>
                  </tr>
                )
              }
            })

          } */}
        </tbody>
      </table>
      {getApprovalUser &&
        <TablePagination
          paginationFor="user_approval_list"
          rowPerPage={10}
          setListCurrentPage={setListCurrentPage}
          totalCount={getApprovalUser.totalNoOfRecords}
        />
      }
      {/* <AddUser
        showModal={showModal}
        setShowModal={setShowModal}
        header={"Edit User"}
        userData={editEle}
      /> */}
      <UpdateApprovalUser
        showModal={showUpdateApprovalUserModal}
        setShowModal={setShowUpdateApprovalUserModal}
        header={"Update User"}
        setSelectedApprovalUser={selectedApprovalUser}
      />
      <ApprovalUser
        showModal={approvalUserModal}
        setShowModal={setApprovalUserModal}
        setSelectedApprovalUser={selectedApprovalUser}
      />

      <Modal show={showDeleteModal} onHide={() => { setShowDeleteModal(false) }} backdrop='static'>
        <Modal.Header className="logout_heading">
          <Modal.Title className="logout_title">Delete Approval User</Modal.Title>
          <button
            type="button"
            className="ms-auto logout_close"
            aria-label="Close"
            onClick={() => { setShowDeleteModal(false) }}
          >X</button>
        </Modal.Header>
        <Modal.Body>
          <label>Are you sure you want to delete this User?</label>

        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => { setShowDeleteModal(false) }}>Cancel</button>
          <button className=" btn btn-primary custom_button   " onClick={() => { comfirmDeleteUserModal(selectedUserRequest.userOasApproval) }} >Confirm</button>
        </Modal.Footer>
      </Modal>

    </div>
  )
}

export default ApprovalUserTable;